import { Button, Stack, type StackProps } from '@mantine/core';
import Lottie from 'lottie-react';

import { checklistAnimation } from '../../assets/lottie';

type Props = {
  onClick: () => void
} & StackProps;

const ProposalProcessingMessage: React.FC<Props> = (props: Props) => {
  const { onClick, ...stackProps } = props;

  return (
    <Stack {...stackProps} align='center'>
      <Lottie
        animationData={checklistAnimation}
        style={{ margin: 0, padding: 0, height: 250 }}
      />
      <Button onClick={onClick}>
        Return to work
      </Button>
    </Stack >
  );
};

export default ProposalProcessingMessage;
